

class NewsletterBlogs {
    constructor(ajaxUrl) {
      this.ajaxUrl = ajaxUrl;
    }
  
    fetchPage(page, filters) {
      var fetch = window.fetch;
      var filters = filters || [];
      var requestUrl = this.ajaxUrl + '?action=theme:newsletter-blog-feed';
      requestUrl += '&page=' + page;
  
      if (filters.length) {
        var sourceFilters = [];
        filters.forEach(field => {
          if (field.value === true) {
            sourceFilters.push(`${field.id}`)
          }
        })
        requestUrl += `&source=${sourceFilters.join(',')}`;
      }

      var request = new window.Request(requestUrl);
  
      return fetch(request)
        .then(function(response) {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then(this.fetchPageComplete);
    }
  
    fetchPageComplete(response) {
      return (response && response.data) ? response.data : [];
    }
  }
  
  var newsletterBlogs = new NewsletterBlogs(window.SBM.ajaxUrl);
  
  
  export default newsletterBlogs;
  
  